export default function formatDateForApi(date) {
  return(
    date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit'}).replaceAll('/', '-')
  )
}

export const formatDateForGraph = (date) => date.toISOString().split('T')[0]